<template>
  <b-modal
    id="gift-card-payment-modal"
    title="Pay with Gift Card"
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    ok-title="Confirm"
    @ok="validateCard()"
    @cancel="emitCloseModal(true)"
    >

    <b-row class="pt-4">
      <b-col cols="2"><b>Order Total</b></b-col>
      <b-col cols="1"></b-col>
      <b-col cols="4"><b>Pay with Gift Card</b></b-col>
      <b-col cols="1"></b-col>
      <b-col cols="3"><b>Outstanding Amount</b></b-col>
    </b-row>
    <b-row class="pt-2">
      <b-col cols="2">{{ order_total | toCurrency}}</b-col>
      <b-col cols="1"> - </b-col>
      <b-col cols="4">
        <b-form-input :state="gcTotalState" v-model="formattedTotal" id="gcTotal"></b-form-input>
        <b-form-invalid-feedback id="gcTotal-feedback">
          Amount cannot exceed order total
        </b-form-invalid-feedback>
      </b-col>
      <b-col cols="1"> = </b-col>
      <b-col cols="3">{{ outstandingAmount | toCurrency }}</b-col>
    </b-row>
    <b-row class="pt-4">
      <b-col>Gift Card Account Number:  </b-col>
      <b-col>
        <b-form-input v-model="gcDetails.gcAccountNumber" id="gcAccNo" type="text"></b-form-input>
        <b-form-text id="gcAccNo-help">This will be the number on your gift card</b-form-text>
      </b-col>
    </b-row>
    <b-row>
      <b-col>Gift Card Pin:  </b-col>
      <b-col><b-form-input v-model="gcDetails.gcPin" type="password"></b-form-input></b-col>
    </b-row>
  </b-modal>
</template>

<script>
export default {
  name: 'GiftCardPaymentModal',
  props: ['order_total', 'gcDets', 'location_id'],
  data () {
    return {
      gcDetails: {
        gcAmount: this.gcDets.gcAmount ? this.gcDets.gcAmount : this.order_total,
        gcAccountNumber: this.gcDets.gcAccountNumber,
        gcPin: this.gcDets.gcPin,
      },
    }
  },

  computed: {
    gcTotalState: function() {
        return (this.outstandingAmount<0) ? false : true
    },

    formattedTotal: {
      get: function() {
        return this.gcDets.gcAmount ? this.$options.filters.toCurrency(this.gcDets.gcAmount) : this.$options.filters.toCurrency(this.order_total);
      },
      set: function(val) {
        this.gcDetails.gcAmount = (val.substr(0,1) == '$') ? Number(val.slice(1)) : Number(val);
      }
    },

    outstandingAmount: function() {
      return Number(Number(this.order_total).toFixed(2) - Number(this.gcDetails.gcAmount).toFixed(2));
    }
  },

  methods: {
    emitSetOverlay(overlay) {
      this.$emit('sidebaroverlay', overlay);
    },

    emitCloseModal(cancel=false) {
      this.emitSetOverlay(true)
      this.gcDetails['outstandingAmount'] = this.outstandingAmount
      this.$emit('emit-close-modal', this.gcDetails, cancel);
    },

    notEnoughFundsModal(balance) {
      this.emitSetOverlay(false)
      this.$bvModal.msgBoxConfirm('You have only '+this.$options.filters.toCurrency(balance)+' on your card, and you are trying to pay '+this.$options.filters.toCurrency(this.gcDetails.gcAmount)+'. Do you want to pay the remaining balance with a credit or debit card?', {
        title: 'Not enough funds on account',
        centered: true
      })
      .then(value => {
        if (value==true) {
          // update the amount to put on the gift card as the balance
          this.gcDetails.gcAmount=balance;
          this.emitCloseModal()
        }
      })
      .catch(err => {
        console.log(err)
      })
    },

    outstandingAmountModal() {
      this.emitSetOverlay(false)
      this.$bvModal.msgBoxConfirm('You still have an outstanding balance of '+this.$options.filters.toCurrency(this.outstandingAmount)+' not covered by the Gift Card. Do you want to pay the remaining balance with a credit / debit card?', {
        title: 'Outstanding Balance',
        centered: true
      })
      .then(value => {
        if (value==true) {
          this.emitCloseModal()
        }
      })
      .catch(err => {
        console.log(err)
      })
    },

    async validateCard() {
      this.emitSetOverlay(true);
      // check account balance
      const balance = await this.checkGiftCardBalance();
      // if not enough funds
      if (Number(balance) < this.gcDetails.gcAmount) {
        this.notEnoughFundsModal(balance);
      // if left outstanding balance
      } else if (this.outstandingAmount > 0) {
        this.outstandingAmountModal();
      // otherwise - all is good
      } else {
        this.emitCloseModal();
      }
    },

    async checkGiftCardBalance() {
      const { data } = await this.$api.get('locations/'+this.location_id+'/gift-card-balance?accno='+this.gcDetails.gcAccountNumber);
      try {
        if (data.success==true && data.ecardsys_response=='Succeeded') {
          return data.balance;
        } else {
          this.makeGCToast()
        }
      } catch(e) {
        console.log(e);
        this.makeGCToast()
      }
    },

    makeGCToast() {
      this.$bvToast.toast('Unable to retrieve gift card information, please check your details and try again.', {
        toaster: 'b-toaster-bottom-right',
        title: 'Gift Card Error',
        autoHideDelay: 5000,
        variant: 'danger'
      })
    },

  },

  mounted() {
    this.$bvModal.show('gift-card-payment-modal');
  }
}
</script>

<style>

</style>
